export const ruoli:string[] = [
  'MEDICO',
  'GENETISTA',
]
  